import { MenuItem, MenuItemProps } from '@mui/material';

import { useSelectMenuItemStyles } from './useSelectMenuItemStyles';

interface SelectMenuItemProps extends MenuItemProps {}

export const SelectMenuItem = (props: SelectMenuItemProps) => {
  const { classes, cx } = useSelectMenuItemStyles();

  return <MenuItem {...props} className={cx(classes.root, props.className)} />;
};
